import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-solicitud-recaudos',
  templateUrl: './solicitud-recaudos.component.html',
  styleUrls: ['./solicitud-recaudos.component.scss'],
})
export class SolicitudRecaudosComponent implements OnInit {
  form: FormGroup;

  @Input() data: { task: any };

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const { task } = this.data;
    const values = task.data ? task.data : null;
    this.form = this.fb.group({
      origen_solicitud: [
        values ? values.origen_solicitud : '',
        [Validators.required],
      ],
      fecha_solicitud: [
        values ? values.fecha_solicitud : '',
        [Validators.required],
      ],
      acta_analisis: [values ? values.acta_analisis : false],
      denuncia_policial: [values ? values.denuncia_policial : false],
      carta_reclamo_cliente: [values ? values.carta_reclamo_cliente : false],
    });
  }

  verificateInput(value: string) {
    return (
      this.form.get(value)?.invalid &&
      (this.form.get(value)?.dirty || this.form.get(value)?.touched)
    );
  }
}
